module.exports = __webpack_public_path__ + "static/media/25UNHCR1.57efb74f.jpg";